/**
 * CardCarousel.js
 */

import $ from 'jquery';
import Flickity from 'flickity-fade';

export default class CardCarousel {

    constructor() {

        this.$slideshow = $('.card-carousel');

        this.enableFlickity();

    }

    bindClickEvents(flickity, element) {



        const buttonRow = $(element).siblings('.button-row');
        
        if (!$('.button--previous', buttonRow).length && !$('.button--next', buttonRow).length) {
            return;
        }



        $('.button--previous', buttonRow).on('click', () => flickity.previous(true));
        $('.button--next', buttonRow).on('click', () => flickity.next(true));
      


        const cellsButtonGroup = buttonRow.children('.carousel-dots').get(0);


        if (cellsButtonGroup) {

            const cellsButtons = Array.from(buttonRow.children('.carousel-dots').children());

            // math to fix excessive dots per viewport we left out, accessibility rules wants a dots for each slide
            // const screens = Math.ceil((flickity.slideableWidth - window.innerWidth/2)/480);
            // const maxDots = window.innerWidth > 1024 ?  screens : cellsButtons.length;
            // cellsButtons.filter((_, i)=> i > maxDots - 1).map(el => el.style.display = 'none' );

            // update buttons on select
            flickity.on('select', function () {
                const previousSelectedButton = cellsButtonGroup.querySelector('.is-selected');
                const selectedButton = cellsButtonGroup.children[flickity.selectedIndex]; // cellsButtonGroup.children[Math.min(maxDots - 1, flickity.selectedIndex)];
                previousSelectedButton.classList.remove('is-selected');
                selectedButton.classList.add('is-selected');
            });

            flickity.on( 'settle', function( index ) {
                $(flickity.selectedCell.element).find('button').focus()
            });

            // cell select
            cellsButtonGroup.addEventListener('click', function (event) {
                if (!$(event.target).hasClass('dot')) {
                    return;
                }
                const index = cellsButtons.indexOf(event.target);
                flickity.select(index);
            });

        }
    }


    enableFlickity() {

        if (!this.$slideshow.length) {
            return;
        }

        this.$slideshow.each((_, element) => {
            const $element = $(element);
            const opts = {
                autoPlay: false,
                cellAlign: 'left',
                contain: true,
                imagesLoaded: true,
                pageDots: false,
                wrapAround: false,
                prevNextButtons: false,
                on: {
                  dragStart: () => {
                    $element.find('.slide').css('pointer-events', 'none')
                  },
                  dragEnd: () => {
                    $element.find('.slide').css('pointer-events', 'all')
                  }
                }
            };

            const flickity = new Flickity(element, {...opts, ...$element.data('flickity')});
            this.bindClickEvents(flickity, element.parentNode);
        });

    }

}
